export interface CloseInvestmentModalConfig {
  title: string | ((item: any) => string);
  hookType: "asset" | "policy" | "bonds";
  showSalePrice?: boolean;
  closedAtLabel?: string;
  closedAtRequired?: boolean;
  showWeight?: boolean;
}

const PROPERTY_TYPE_LABELS: Record<string, string> = {
  apartment: "Mieszkanie",
  house: "Dom",
  land: "Działka",
};

const METAL_TYPE_LABELS: Record<string, string> = {
  gold: "Złoto",
  silver: "Srebro",
};

const getPreciousMetalLabel = (item: any): string => {
  const metalType = item?.details?.metalType;
  if (!metalType) return item?.name || "Metale szlachetne";
  if (metalType === "other") return item?.details?.metalTypeOther || "Inne";
  return METAL_TYPE_LABELS[metalType] ?? metalType;
};

const getPropertyLabel = (item: any): string => {
  if (!item) return "";
  const propertyType = item.details?.propertyType;
  if (!propertyType) return item.name || "";
  if (propertyType === "other") return item.details?.propertyTypeOther || "Inne";
  return PROPERTY_TYPE_LABELS[propertyType] ?? propertyType;
};

export const CLOSE_INVESTMENT_CONFIGS = {
  realEstate: {
    hookType: "asset" as const,
    showSalePrice: true,
    closedAtLabel: "Data sprzedaży",
    closedAtRequired: true,
    title: (item: any) => `Sprzedaż Nieruchomości "${getPropertyLabel(item)}"`,
  },
  otherAsset: {
    hookType: "asset" as const,
    showSalePrice: true,
    closedAtLabel: "Data sprzedaży",
    closedAtRequired: true,
    title: (item: any) => `Sprzedaż Inne aktywo "${item?.name || "Inne aktywo"}"`,
  },
  loan: {
    hookType: "asset" as const,
    showSalePrice: false,
    closedAtLabel: "Data zamknięcia",
    closedAtRequired: true,
    title: "Zamknij pożyczkę",
  },
  policy: {
    hookType: "policy" as const,
    showSalePrice: false,
    closedAtLabel: "Data zamknięcia",
    closedAtRequired: true,
    title: "Zamknij Polisę inwestycyjną / IKE",
  },
  treasuryBonds: {
    hookType: "bonds" as const,
    showSalePrice: false,
    closedAtLabel: "Data zamknięcia",
    closedAtRequired: true,
    title: "Zamknij obligacje skarbowe",
  },
  preciousStones: {
    hookType: "asset" as const,
    showSalePrice: true,
    showWeight: true,
    closedAtRequired: false,
    title: (item: any) => `Sprzedaż kamienia szlachetnego "${item?.name || ""}"`,
  },
  artwork: {
    hookType: "asset" as const,
    showSalePrice: true,
    closedAtLabel: "Data sprzedaży",
    closedAtRequired: true,
    title: (item: any) => `Sprzedaż dzieła sztuki "${item?.name || ""}"`,
  },
  preciousMetals: {
    hookType: "asset" as const,
    showSalePrice: false,
    closedAtLabel: "Data zamknięcia",
    closedAtRequired: true,
    title: (item: any) => `Zamknij aktywo "${getPreciousMetalLabel(item)}"`,
  },
} satisfies Record<string, CloseInvestmentModalConfig>;
